import { DashboardPage } from '@/features/dashboard/dashboard-page'

/**
 * LandingRoute — where a logged-in tenant user lands at "/". Platform accounts
 * never reach here: RequireAuth intercepts them before the tenant shell mounts.
 */
export function LandingRoute() {
  return <DashboardPage />
}
